module.exports = __webpack_public_path__ + "img/BYRD_AI_horizontal_white.fcc19fd7.png";